module.exports = __webpack_public_path__ + "static/media/IMG_8937.5222756e.JPG";